import { clamp } from 'lodash';

export function calculateWidth(value: string, fullValue: number): number {
  if (value.endsWith('%')) {
    const percent = clamp(parseFloat(value.slice(0, value.length - 1)), 0, 100);
    return (percent / 100) * fullValue;
  }
  return parseFloat(value);
}
